export const cloudinary = {
    methods: {
        //add optimization transformations to cloudinary photography. Default to 1200 if width is not provided.
        addImageOptimizationTransforms(imageString, width) {
            //set default value of width if it's not provided.
            width = width ? width : 1200;
            //console.log(imageString);
            try {
                if(imageString) {
                    // regular expression pattern to insert our transform instructions into the URL, regardless of format.
                    // 3 part pattern, we reference these part with '$1','$2','$3' respectively inside of the replace function.
                    let pattern = /(\/upload)(\/[^/]+)*?(\/v)/;
                    return imageString.replace(pattern, '$1' + '/fl_lossy,c_limit,f_auto,q_auto:best,w_' + width + '$3');
                }
                return imageString;
            } catch (error) {
                console.log('Could not optimize cloudinary Photography:', error);
                return imageString;
            }
        },

        //add optimization transformations to cloudinary video files. Default to 1200 if width is not provided.
        addVideoOptimizationTransforms(videoString, width) {
            //set default value of width if it's not provided.
            width = width ? width : 1200;
            //console.log(imageString);
            try {
                if(videoString) {
                    // regular expression pattern to insert our transform instructions into the URL, regardless of format.
                    // 3 part pattern, we reference these part with '$1','$2','$3' respectively inside of the replace function.
                    let pattern = /(\/upload)(\/[^/]+)*(\/v)/;
                    return videoString.replace(pattern, '$1' + '/f_auto,q_auto,w_' + width + '$3');
                }
                return videoString;
            } catch (error) {
                console.log('Could not optimize cloudinary Video:', error);
                return videoString;
            }
        },

        //thumbnailify
        thumbnailify(imageString, width) {
          //set default value of width if it's not provided.
          width = width ? width : '120x';
          // Ensure imageString is provided
          if (!imageString) {
            console.log('No image string provided');
            return imageString;
          }
    
          try {
            // Create a regular expression to match either '_700x.png' or '_1200x.png'
            const regex = /(_700x|_1200x|_300x)(?=\.png)/;
    
            // Perform the replacement and log the updated URL
            const updatedString = imageString.replace(regex, `_${width}.png`);
            console.log('Updated Image URL dawg:', updatedString);
    
            return updatedString;
          } catch (error) {
            console.log('Could not shrink:', error);
            return imageString;
          }
        },
    }
};